import React from 'react';
import { InputItem } from 'antd-mobile';
import WrapComponent from './WrapComponent';

class Email extends React.PureComponent{
    render(){
        let {api_name, form, default_value, is_required, is_readonly, label, errorText} = this.props;
        const {getFieldProps} = form;
        
        let tempProps = {
            type: 'email',
            name: api_name,
            disabled: is_readonly,
            placeholder: $st('请输入')
        }
        let fieldProps = getFieldProps(api_name, {
            initialValue: default_value,
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`该项是必填项`)
                }]
            },{
                trigger: 'onChange',
                rules: [{
                    type: 'email',
                    // pattern: props.pattern,
                    message: `${label}`+$st(`格式不正确`)
                }]
            }]
        })
        return (
            <InputItem {...tempProps} {...fieldProps} >
                {errorText && <div className='input-error'>{errorText}</div>}
            </InputItem>
        )
    }
}
export default WrapComponent(Email);


// WEBPACK FOOTER //
// ./src/component/Email.js